<template>
  <div class="infor">
    <div class="scrm-section">
      <div class="scrm-section__head">
        <div class="scrm-section__title">实时概况</div>
        <div class="scrm-section__tip">
          <span>
            更新时间: 2020-01-09 09:50:07
          </span>
        </div>
      </div>
      <div class="scrm-section__content">
        <div class="lft">
          <div class="data-item-blocks">
            <div
              class="data-block-item"
              v-for="(item, index) in accounts"
              :key="index"
            >
              <div class="data-block-item__title">{{ item.title }}</div>
              <div class="data-block-item__value">
                <div class="data-block-item__value">￥{{ item.sumNum }}</div>
                <div class="data-block-item__compare">昨日：￥{{ item.yesNum }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rgt">
          <div class="data-item-blocks">
            <div class="data-block-item">
              <div class="data-block-item__title">访客数</div>
              <div class="data-block-item__value">
                <div class="data-block-item__value">0</div>
                <div class="data-block-item__compare">昨日：0</div>
              </div>
            </div>
            <div class="data-block-item address">
              <div class="progress">
                <el-progress type="circle" :percentage="25" width="70"></el-progress>
                <span>暂无数据</span>
              </div>
              <div class="hint">
                <p>购买用户</p>
                <p>未购买用户</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="scrm-section">
      <div class="scrm-section__head">
        <div class="scrm-section__title">到店离店</div>
      </div>
      <div class="scrm-section__content">
        <div class="lft">
          <div class="data-item-blocks">
            <div
              class="data-block-item block-lft-rgt"
              v-for="(item, index) in twoData"
              :key="index"
            >
              <div class="img">
                <img :src="item.imgUrl" alt="" />
              </div>
              <div class="cont">
                <div class="name">
                  {{ item.name }}
                </div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="scrm-section">
      <div class="scrm-section__head">
        <div class="scrm-section__title">持续复购</div>
      </div>
      <div class="scrm-section__content">
        <div class="_2pw5 _2_ml" v-for="item in 3" :key="item">
          <div class="Ri4X">
            <div class="_3YnZ">
              <img src="//b.yzcdn.cn/public_files/2019/07/17/b37c867b995c4f05bc10eceb873e6b2a.png" alt="">
            </div>
            <span>精准触达</span>
          </div>
          <div class="JNH0">
            <div class="number">
              <div class="Mb12">累计会员数</div>
              <div style="font-size: 28px;color: #323233">0</div>
            </div>
            <div class="hintText">
              每周会员日，培养会员复购习惯
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accounts: [
        {
          title: "支付金额",
          sumNum: "0.00",
          yesNum: "0.00"
        },
        {
          title: "支付人数",
          sumNum: "0.00",
          yesNum: "0.00"
        },
        {
          title: "客单价",
          sumNum: "0.00",
          yesNum: "0.00"
        }
      ],
      twoData: [
        {
          imgUrl:
            "//b.yzcdn.cn/public_files/2019/07/17/082cefd834c29c6a86af8105a2f5491b.png",
          name: "进店有礼",
          text: "促成进店客户购买转化"
        },
        {
          imgUrl:
            "//b.yzcdn.cn/public_files/2019/07/17/4dcb849cb322de57c6ea8cac06fc2875.png",
          name: "进店有礼",
          text: "促成进店客户购买转化"
        },
        {
          imgUrl: "//b.yzcdn.cn/public_files/2019/07/17/082cefd834c29c6a86af8105a2f5491b.png",
          name: "进店有礼",
          text: "促成进店客户购买转化"
        },
        {
          imgUrl: "//b.yzcdn.cn/public_files/2019/07/17/4acb99cf7af1b746d3ce7e2726dc0af2.png",
          name: "进店有礼",
          text: "促成进店客户购买转化"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.infor {
  margin: 24px;
  .scrm-section {
    padding: 20px 24px 30px;
    background-color: #fff;
    margin-bottom: 24px;
    .scrm-section__head {
      display: flex;
      align-items: center;
      flex-direction: row;
      margin-bottom: 24px;
      .scrm-section__title {
        font-size: 20px;
        color: #333;
        font-weight: 500;
        line-height: 28px;
      }
      .scrm-section__tip {
        flex: 1;
        color: #999;
        padding-left: 10px;
        font-size: 14px;
      }
    }
    .scrm-section__content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .lft {
        flex: 3;
      }
      .rgt {
        flex: 2;
        border-left: 1px solid #ebebeb;
        padding-left: 10px;
      }
      .data-item-blocks {
        display: flex;
        .address {
          display: flex;
          flex-direction: row;
        }
        .data-block-item {
          flex: 1;
          padding-left: 24px;
          .progress {
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .hint {
            width: 50%;
            line-height: 20px;
            font {
              size: 16px;
            }
            color: #999;
          }
          .data-block-item__title {
            font-size: 14px;
            color: #969799;
            font-weight: 400;
          }
          .data-block-item__value {
            margin: 12px 0 10px;
            font-size: 28px;
            // font-weight: 700;
            .data-block-item__compare {
              font-size: 14px;
              color: #969799;
              font-weight: 400;
            }
          }
        }
        .block-lft-rgt {
          display: flex;
          flex-direction: row;
          .img {
            width: 40px;
            height: 40px;
            margin-right: 15px;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          .cont {
            color: #969799;
            .name {
              font-size: 14px;
              color: #323233;
              font-weight: 500;
              margin-bottom: 5px;
            }
          }
        }
      }
      ._2pw5 {
        box-sizing: border-box;
        width: calc(50% - 24px);
        margin-right: 24px;
        margin-bottom: 24px;
        display: inline-block;
        border: 1px solid #ebedf0;
        .Ri4X {
          height: 56px;
          display: flex;
          align-items: center;
          background-color: #f7f8fa;
          padding-left: 24px;
          font-size: 16px;
          font-weight: 500;
          ._3YnZ {
            width: 18px;
            height: 18px;
            margin-right: 9px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .JNH0 {
          position: relative;
          min-height: 100px;
          padding-top: 20px;
          padding-bottom: 30px;
          box-sizing: border-box;
          display: flex;
          .number {
            flex: 4;
            border-right: 1px solid #ebedf0;
            padding-left: 32px;
            .Mb12 {
              color: #969799;
              font-size: 14px;
              line-height: 1.5;
              margin-bottom: 12px;
            }
          }
          .hintText {
            flex: 6;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #969799;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
